import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import SearchFilterBox from "../../Components/SearchFilterBox";
import Table from "../../Components/Landlords/Table";
import { toast } from "react-toastify";
import SideModal from "../../Components/SideModal";
import ViewPropsModel from "../../Components/Landlords/ViewPropsModel";
import AddLandlord from "../../Components/Landlords/AddLandlord";
import ViewKYCDetail from "../../Components/Landlords/ViewKYCDetail";
import { useUploadLandlordDocument } from "../../utilities/usePropertyLeaseHooks";

const LandlordsList = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
    { label: "Prop Name", value: 3 },
  ];

  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showViewLeaseModel, setShowViewLeaseModel] = useState(false);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [leaseData, setLeaseData] = useState("");
  const [isUnpaidExpense, setIsUnPaidExpense] = useState(false);
  const [showEditLandlord, setShowEditLandlord] = useState(false);
  const [showAddLandlord, setShowAddLandlord] = useState(false);
  const [showViewProps, setShowViewProps] = useState(false);
  const [unpaidExpenseData, setUnpaidExpensesData] = useState("");
  const [showEditLeaseModel, setShowEditLeaseModel] = useState(false);
  const [showManagePaymentModel, setShowManagePaymentModel] = useState(false);
  const [isMarkAsPaidVisible, setIsMarkAsPaidVisible] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [isAddDuesModal, setIsAddDuesModal] = useState(false);

  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
    const response = await axios.get(
      `${Config.apiUrl}/landlord/records/list?${query}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess) {
      setApiData(res.landlords);
      setIsFocused(true);
    }
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate({ searchQuery, filterType });
  }, []);

  const handleFilterChange = (values) => {
    sessionStorage.removeItem("landlord_list_page");
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    getListMutate({
      searchQuery: values.searchQuery,
      filterType: values.filterType,
    });
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };

  // Handle Document Upload
  // const handleDocumentUpload = async (values) => {
  //   return await axios.post(
  //     `${Config.apiUrl}/client/landlord/docs/upload`,
  //     values,
  //     {
  //       headers: {
  //         authorization: "Bearer" + " " + user.token,
  //         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  //       },
  //     }
  //   );
  // };

  // const onAddDocumentSuccess = (data) => {
  //   if (data?.data?.isSuccess === true) {
  //     toast.success(data?.data?.msg || "Success");
  //     setShowUploadForm(false);
  //   } else {
  //     toast.error(data?.data?.msg || "An Error Occured");
  //   }
  // };

  // const onAddDocumentError = (data) => {
  //   toast.error(data?.response?.data?.msg || "An Error Occured");
  // };

  // const {
  //   isLoading: addDocumentLoading,
  //   mutate: addDocumentMutate,
  //   data: documentData,
  // } = useMutation(handleDocumentUpload, {
  //   onSuccess: onAddDocumentSuccess,
  //   onError: onAddDocumentError,
  // });


  const {
    mutate: addDocumentMutate,
    isLoading: addDocumentLoading,
    data: documentData,
  } = useUploadLandlordDocument({
    token: user.token,
    onSuccessCallback: (res) => {
      if (res?.isSuccess === true) {
        toast.success(res?.msg || "Success");
        setShowUploadForm(false);
        //setShowViewLeaseModel(false);
      } else {
        toast.error(res?.data?.msg || "An error occurred");
      }
    },
    onErrorCallback: (error) => {
      toast.error(
        error?.response?.data?.msg || "An error occurred"
      );
    },
  });

  const handleCloseLeaseViewModal = () => {
    setShowViewLeaseModel(false);
  };

  const handleCloseEditLandlord = () => {
    setShowEditLandlord(false);
  };
  const handleCloseAddLandlord = () => {
    setShowAddLandlord(false);
  };

  const handleCloseViewProps = () => {
    setShowViewProps(false);
  };

  //------- Add Landlord details -------
  const addLandlordFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/landlord/add`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const addLandlordSuccess = (data) => {
    setShowAddLandlord(false);
    getListMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  };

  const addLandlordError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addLandlordLoading, mutate: addLandlordMutate } =
    useMutation(addLandlordFunction, {
      onSuccess: addLandlordSuccess,
      onError: addLandlordError,
    });

  //------- Save Payment details -------
  const useSavePaymentMutate = (handleClose, refetch) => {
    return useMutation({
      mutationFn: async (data) => {
        // POST API call to save landlord payment details
        const response = await axios.post(
          `${Config.apiUrl}/landlord/manage/paymentdetail`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${user.token}`,
            },
          }
        );
        return response.data;
      },

      onSuccess: (res) => {
        toast.success(res?.msg || "Payment details saved successfully");
        if (refetch) refetch(); // refetch parent list if needed
        if (handleClose) handleClose(); // close modal or form
      },

      onError: (error) => {
        const errMsg =
          error?.response?.data?.msg ||
          error?.message ||
          "Failed to save payment details";
        toast.success(errMsg, "error");
      },
    });
  };

  //------- Pay rent to Landlord -------
  const markAsPaidFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/landlord/payment/init`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const markAsPaidSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      if (data?.data?.link) {
        setIsMarkAsPaidVisible(false);
        setIsUnPaidExpense(false);
        window.open(data.data.link, "_blank", "noopener,noreferrer");
      }
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const markAsPaidError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: markAsPaidLoading, mutate: markAsPaidMutate } =
    useMutation(markAsPaidFunction, {
      onSuccess: markAsPaidSuccess,
      onError: markAsPaidError,
    });

  //------- Add Due -------
  // const addDueFunction = async (payload) => {
  //   return await axios.post(`${Config.apiUrl}/expense/add/new`, payload, {
  //     headers: {
  //       authorization: `Bearer ${user.token}`,
  //     },
  //   });
  // };

  // const { isLoading: addDuesLoading, mutate: addDuesMutate } = useMutation(
  //   addDueFunction,
  //   {
  //     onSettled: () => {
  //       setIsAddDuesModal(false);
  //     },
  //     onSuccess: ({ data }) => {
  //       getListMutate({ searchQuery, filterType });
  //       toast.success(data?.msg || 'Success');
  //     },
  //     onError: (error) => {
  //       toast.error(error?.response?.data?.msg || 'An error occurred');
  //     },
  //   }
  // );

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Landlords
          <Underline />
        </BoxTitle>
        <div className="flex space-x-4 md:ml-auto">
          <AddBtn
            type="button"
            onClick={() => {
              setShowAddLandlord(true);
            }}
          >
            {"Add Landlord"}
          </AddBtn>
        </div>
      </BoxHead>

      {/* <SideModal
        isOpen={isAddDuesModal}
        onClose={() => setIsAddDuesModal(false)}
      >
        <AddDuesModal
          setIsAddDuesModal={setIsAddDuesModal}
          addDuesMutate={addDuesMutate}
          addDuesLoading={addDuesLoading}
          isAddDuesModal={isAddDuesModal}
          selectedData={selectedData}
        />
      </SideModal> */}

      <SideModal
        isOpen={showViewLeaseModel}
        onClose={handleCloseLeaseViewModal}
      >
        <ViewKYCDetail
          handleClose={handleCloseLeaseViewModal}
          selectedData={selectedData}
          setShowUploadForm={setShowUploadForm}
          showUploadForm={showUploadForm}
          addDocumentLoading={addDocumentLoading}
          addDocumentMutate={addDocumentMutate}
          documentData={documentData}
          setShowViewLeaseModel={setShowViewLeaseModel}
        />
      </SideModal>

      {/* <SideModal
        isOpen={showEditLandlord}
        onClose={handleCloseEditLandlord}
        level="base"
      >
        <EditLandlord
          handleClose={handleCloseEditLandlord}
          selectedData={selectedData}
          editLandlordMutate={editLandlordMutate}
          editLandlordLoading={editLandlordLoading}
        />
      </SideModal> */}
      <SideModal
        isOpen={showAddLandlord}
        onClose={handleCloseAddLandlord}
        level="base"
      >
        <AddLandlord
          handleClose={handleCloseAddLandlord}
          selectedData={selectedData}
          addLandlordMutate={addLandlordMutate}
          addLandlordLoading={addLandlordLoading}
        />
      </SideModal>

      <SideModal
        isOpen={showViewProps}
        onClose={handleCloseViewProps}
        level="base"
      >
        <ViewPropsModel
          handleClose={handleCloseViewProps}
          selectedData={selectedData}
        // setSelectedExpense={setSelectedExpense}
        // editLandlordMutate={editLandlordMutate}
        // editLandlordLoading={editLandlordLoading}
        />
      </SideModal>

      <FilterTableWrapper>
        <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {/* Left: Total Amount */}
          <div className="flex items-center">
            <Text>
              Total landlords:{" "}
              <span className="font-semibold">
                {apiData?.length || 0}
              </span>
            </Text>
          </div>

          {/* Right: Search / Filters */}
          <div className="flex flex-col gap-3 md:flex-row md:justify-end md:items-center">
            <SearchFilterBox
              options={searchOptions}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
            />
          </div>
        </FilterWrapper>
        {!error && !isLoading && data && (
          <TableWrapper>
            <Table
              apiData={apiData || []}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              //handleFetch={handleFetch}
              // setShowEditLandlord={setShowEditLandlord}
              setShowViewProps={setShowViewProps}
              setShowViewLeaseModel={setShowViewLeaseModel}
            //setIsAddDuesModal={setIsAddDuesModal}
            //handleUnpaidExpensesFetch={handleUnpaidExpensesFetch}
            />
            {(!apiData || apiData.length === 0) && <NotFoundModel />}
          </TableWrapper>
        )}
      </FilterTableWrapper>

      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;
const AddBtn = tw.button`whitespace-nowrap flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;

const Text = tw.p`text-gray-500 text-sm font-normal`;

export default LandlordsList;
